import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {Drawer, Typography, Icon, Menu, Button, Modal, message, Tabs} from 'antd';
import {klicountrynames} from '../../stores/APIEndpoints';
import TitleBar from '../TitleBar';
import About from '../About';
import SummaryTable from './SummaryTable';
import {appStore} from '../../stores/AppStore';
import DynamicForm from "../DynamicForm";
import AgGrid from "../AgGrid";
import store from '../../stores/DashboardStore';
import LooseLeafSchedulerDrawer from "../../components/looseLeaf/LooseLeafScheduleDrawer";
import LooseLeafChasingUnits from "../../components/looseLeaf/LooseLeafChasingUnits";
import LooseLeafPeopleDrawer from "../../components/looseLeaf/LooseLeafPeopleDrawer";
import LooseLeafPrimaryInformationDrawer from "../../components/looseLeaf/LooseLeafPrimaryInformationDrawer";
import LooseLeafDrawer from "../../components/looseLeaf/LooseLeafDrawer";
import LooseLeafConfiguration from "../looseLeaf/LooseLeafConfiguration";
import LooseLeafLapsCallLogs from '../looseLeaf/LooseLeafLapsCallLogs';

const { TabPane } = Tabs;


const {Text} = Typography;
const {confirm} = Modal;

export default @observer
class LooseLeafs extends Component {
    state = {
        deleteModalLoading: false,
       
    };

    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
            current: 'AllAcquisition',
        }
    }

    async componentDidMount() {
        await store.fetchData();
        if(store.rowData.length == 0){
                    store.rowData = [{classification: "No data"}]
                }
    }
    handleClick = e => {
        console.log('click ', e);
        this.setState({
          current: e.key,
        });
      };
    render() {
       
        return (
            <div style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                height: '100%'
            }}>
               
                <TitleBar/>
                {this.renderDrawer()}
                <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal">
                    <Menu.Item key="AllAcquisition" onClick={()=>store.clickCustomFilter('all')} >
                    <Icon type="home"/>
                         Dashboard
                    </Menu.Item>
                    <Menu.Item key="SummaryTable" onClick={()=>store.getSummaryData()}>
                    <Icon type="dot-chart" twoToneColor="green" />
                          Summary Table
                    </Menu.Item>
                    <Menu.Item key="AwaitingAcquisition" onClick={()=>store.clickCustomFilter('awaiting')} >
                    <Icon type="smile" theme="twoTone"/>
                          Awaiting Acquisition
                    </Menu.Item>
                    <Menu.Item key="PlannedAcquisition" onClick={()=>store.clickCustomFilter('planned')} >
                    <Icon type="sync" spin twoToneColor="#52c41a" />
                        Planned Acquisition
                    </Menu.Item>
                    <Menu.Item key="InAcquisition" onClick={()=>store.clickCustomFilter('in')} >
                    <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                           In Acquisition
                    </Menu.Item>
                    <Menu.Item key="DoNotChase" onClick={()=>store.clickCustomFilter('donotchase')}>
                    <Icon type="pause-circle" theme="twoTone"  twoToneColor="red"   />
                          Do Not Chase
                    </Menu.Item>
                  
                    <Menu.Item key="Configuration">
                    <Icon type="setting" />
                         Configuration
                    </Menu.Item>
                    <Menu.Item key="AboutUs">
                    <Icon type="idcard" />
                         About Us
                    </Menu.Item>

                </Menu>
                {this.state.current != 'AboutUs' && this.state.current != 'Configuration' ?
                
                <AgGrid
                    deltaRowDataMode={true}
                    rowData={store.rowData}
                    columnDefs={store.columnDefs}
                    onGridReady={this.onGridReady}
                    enableSorting={true}
                    enableFilter={true}
                    onCellClicked={this.handleCellClicked}
                    enableColResize={true}
                    getRowNodeId={(data) => data.id}
                />:""}
                {this.state.current == 'AboutUs'? <div><About /></div>:''}
                {/* {this.state.current == 'SummaryTable'? <div></div>:''} */}
                {this.state.current == 'Configuration'? <LooseLeafConfiguration />:''}
               
            </div>
        )
    }

    handleCellClicked = (params) => {
        let copyDublicate = ['abbreviation','countryId','globalWorkflowId','leafType','classification','future_author','future_authorEmails','future_cm','future_cmEmails','future_editor','future_editorEmails','msAbstractTaskId','msActor','reseedType','recyclePeriod'];
        let getDublicates={};
        const {data} = params;
        
        if(data == undefined)
        {
            return false;
        }
        store.selectedApprevation = params.data.abbreviation;
        if(params.column.colId == "rowno")
        {   
                store.activeTab = '0';
                getDublicates['abbreviation'] = params.data.abbreviation;
                getDublicates['countryId'] = params.data.countryId;
                getDublicates['globalWorkflowId'] = params.data.globalWorkflowId;
                getDublicates['leafType'] = params.data.leafType;
                getDublicates['classification'] = params.data.classification;
                getDublicates['future_author'] = params.data.future_author;
                getDublicates['future_authorEmails'] = params.data.future_authorEmails;
                getDublicates['future_cm'] = params.data.future_cm;
                getDublicates['future_cmEmails'] = params.data.future_cmEmails;
                getDublicates['future_editor'] = params.data.future_editor;
                getDublicates['future_editorEmails'] = params.data.future_editorEmails;
                getDublicates['msAbstractTaskId'] = params.data.msAbstractTaskId;
                getDublicates['reseedType'] = params.data.reseedType;
                getDublicates['recyclePeriod'] = params.data.recyclePeriod;
                getDublicates['titleId'] = params.data.titleId;
                getDublicates['abstractTaskId'] = params.data.abstractTaskId;
                this.countryChange(params.data.countryId);
            store.setCurrentData(getDublicates);
            console.log(getDublicates);
            
            return false;
        }
        this.countryChange(params.data.countryId);
        store.setCurrentData(data);
    };
    countryChange =async(value)=>{
      
      const bodyParams = {
            "where": {id: value.toString()},
            "limit": "5"
      }
      let response = await this.apiProxy.asyncPost(klicountrynames, bodyParams);
      const option = await response.json();
      store.getCountryName=option[0].country;
    }
    callback=(key)=>{
        console.log(key);
    }
    onChangeTab = activeTab => {
        //this.setState({"activeTabState":looseLeafStore.activeKey});
        store.activeTab = activeTab;
    };
    changePublishedDate=()=>{
        alert();
    }
  
    renderDrawer = () => {
        const currentData = store.currentData;
        if (!store.drawerVisible) return null;
        let data = store.getFormDefs()
       
        if(store.selectedApprevation == 'MIP')
        {
             data.splice(3,1);
            
        }
        else
        {
            data.splice(6,2);
        }
        return (
            <Drawer
                title={this.renderDrawerTitle(store.currentData)}
                width={'40%'}
                onClose={store.unfocus}
                visible={store.drawerVisible}>
                <div className={'formContainer'}>
                <Tabs activeKey={store.activeTab} tabPosition='top' onChange={this.onChangeTab}>
                    <TabPane tab="Primary Information" key={"0"}>
                    <LooseLeafPrimaryInformationDrawer dataStore={data}></LooseLeafPrimaryInformationDrawer>
                        {/* <DynamicForm
                            items={data}
                            submitButtonText={'Save'}
                            onSubmit={store.updateItem}
                        /> */}
                    </TabPane>
                    <TabPane tab="People" key={"1"}>
                         <LooseLeafPeopleDrawer dataStore={data}></LooseLeafPeopleDrawer>
                    </TabPane>
                    <TabPane tab="Schedule" key={"2"}>
                         <LooseLeafSchedulerDrawer dataStore={data}></LooseLeafSchedulerDrawer>
                    </TabPane>
                        { currentData.projectId > 0 ?
                    <TabPane tab="Chasing Units" key={"3"}>
                         <LooseLeafChasingUnits dataStore={data}></LooseLeafChasingUnits>
                    </TabPane>:'' }
                    {/* <TabPane tab="Logs" key={"4"}>
                         <LooseLeafLapsCallLogs dataStore={data}></LooseLeafLapsCallLogs>
                    </TabPane> */}
                </Tabs>
                </div>
            </Drawer>
        );
    };

    showDeleteConfirmation = () => {
        const item = store.currentData;

        confirm({
            title: `Do you Want to delete ${item.abbreviation} ${item.publication}?`,
            okType: 'danger',
            onOk: async () => {
                try {
                    await store.deleteLooseLeaf(item);
                    store.unfocus();
                    message.success('Deleted');
                } catch (e) {
                    message.error('Unable to delete. Please try later');
                }
            },
            onCancel() {
            },
        });
    };

    renderDrawerTitle = item => {
        let {publication, author, status} = item;
        const canDeleteLooseLeaf = status === 'Available' || status === 'Do Not Chase';
        if(author==null)
        {
            author='';
        }
        return (
            <div style={styles.drawerTitleContainer}>
            {publication!=undefined?
            <div style={{color:'#fff'}}>Edit - {`${publication} - ${author}`}</div>:<div style={{color:'#fff'}}>New</div>}
            {
                canDeleteLooseLeaf ?
                    (<span>
                        &#160;&#160;<Icon type="delete" onClick={this.showDeleteConfirmation} theme="twoTone" twoToneColor="#eb2f96"/>
                    </span>) : null
            }
        </div>
        );
    }
}


const styles = {
    drawerTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 30
    }
};
